module.exports = __webpack_public_path__ + "img/card-logo.4674fae0.svg";